import { render, staticRenderFns } from "./SessionDetailQuestion.vue?vue&type=template&id=18a87bb0&scoped=true&"
import script from "./SessionDetailQuestion.vue?vue&type=script&lang=js&"
export * from "./SessionDetailQuestion.vue?vue&type=script&lang=js&"
import style0 from "./SessionDetailQuestion.vue?vue&type=style&index=0&id=18a87bb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a87bb0",
  null
  
)

export default component.exports